import type { AllFieldType } from '@/src/Types/GF/Fields';

import AddressField from './Fields/Advanced/AdressField';
import ConsentField from './Fields/Advanced/ConsentField';
import DateField from './Fields/Advanced/DateField';
import EmailField from './Fields/Advanced/EmailField';
import FileField from './Fields/Advanced/FileField';
import MultiSelectField from './Fields/Advanced/MultiSelectField';
import NameField from './Fields/Advanced/NameField';
import PhoneField from './Fields/Advanced/PhoneField';
import TimeField from './Fields/Advanced/TimeField';
import WebsiteField from './Fields/Advanced/WebsiteField';
import CheckboxField from './Fields/Standard/CheckBoxField';
import HiddenField from './Fields/Standard/HiddenField';
import HtmlField from './Fields/Standard/HtmlField';
import NumberField from './Fields/Standard/NumberField';
import RadioField from './Fields/Standard/RadioField';
import SectionField from './Fields/Standard/SectionField';
import SelectField from './Fields/Standard/SelectField';
import TextAreaField from './Fields/Standard/TextAreaField';
import TextField from './Fields/Standard/TextField';
import { evaluateConditionnalLogic } from './lib';

type GravityFormsFiedlType = {
	field: AllFieldType;
	formValues: any;
	setFormValues: React.Dispatch<any>;
	errorMessage: any;
	fields: AllFieldType[];
};

export default function GravityFormsField(props: GravityFormsFiedlType) {
	const { field, setFormValues, formValues, errorMessage, fields } = props;

	let _errorMessage = '';

	if (errorMessage && Object.prototype.hasOwnProperty.call(errorMessage, field.id)) {
		_errorMessage = field.errorMessage ? field.errorMessage : errorMessage[field.id];
	}

	if (field.visibility === 'visible') {
		if (
			!field.conditionalLogic ||
			evaluateConditionnalLogic(field.conditionalLogic, formValues, fields)
		) {
			const props = {
				setFormValues: setFormValues,
				formValues: formValues,
				errorMessage: _errorMessage,
			};

			switch (field.type) {
				case 'name':
					return <NameField {...props} field={field} />;
				case 'text':
					return <TextField {...props} field={field} />;
				case 'textarea':
					return <TextAreaField {...props} field={field} />;
				case 'select':
					return <SelectField {...props} field={field} />;
				case 'number':
					return <NumberField {...props} field={field} />;
				case 'radio':
					return <RadioField {...props} field={field} />;
				case 'checkbox':
					return <CheckboxField {...props} field={field} />;
				case 'date':
					return <DateField {...props} field={field} />;
				case 'time':
					return <TimeField {...props} field={field} />;
				case 'phone':
					return <PhoneField {...props} field={field} />;
				case 'address':
					return <AddressField {...props} field={field} />;
				case 'website':
					return <WebsiteField {...props} field={field} />;
				case 'email':
					return <EmailField {...props} field={field} />;
				case 'consent':
					return <ConsentField {...props} field={field} />;
				case 'multiselect':
					return <MultiSelectField {...props} field={field} />;
				case 'fileupload':
					return <FileField {...props} field={field} />;
				case 'hidden':
					return <HiddenField field={field} />;
				case 'html':
					return <HtmlField field={field} />;
				case 'section':
					return <SectionField field={field} />;
				default:
					return <p>{`Field type not supported`}</p>;
			}
		} else {
			return;
		}
	}
}
